import React, {createContext, useReducer} from 'react'
import {LidarOverviewReducer} from "../reducer/LidarOverviewReducer";

export const LidarOverviewContext = createContext();

const LidarOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        lidarDeviceInformation: {},
        macAddressArray: [],
        deviceConnectivityList: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(LidarOverviewReducer, data)
    return (
        <LidarOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </LidarOverviewContext.Provider>
    )
}

export default LidarOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/context/LidarOverviewContext.js